import { render, staticRenderFns } from "./performance-observation.vue?vue&type=template&id=cda7a4b8"
import script from "./performance-observation.vue?vue&type=script&lang=js"
export * from "./performance-observation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports